export interface TDebouncedFn {
  (...args: unknown[]): void;
  cancel(): void;
}

export function debounce(callback, waitTime: number): TDebouncedFn {
  let timeoutId;

  const debounced = function (...args: unknown[]): void {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      callback.apply(this, args);
    }, waitTime);
  } as TDebouncedFn;

  debounced.cancel = (): void => {
    clearTimeout(timeoutId);
    timeoutId = undefined;
  };

  return debounced;
}
